import { useState } from 'react';
import { Helmet } from 'react-helmet';
import retangle from '../Media/Rectangle.png';
import Header from './Header/Header';
import LoadingAnimation from './LoadingAnimation';
import './Styles/reel.css';

import AliceCarousel from 'react-alice-carousel';
import { Carousel } from 'react-responsive-carousel';
import ferramenta_reels_img1 from '../Media/ferramenta-reels-img1.jpeg';
import ferramenta_reels_img10 from '../Media/ferramenta-reels-img10.jpeg';
import ferramenta_reels_img2 from '../Media/ferramenta-reels-img2.jpeg';
import ferramenta_reels_img3 from '../Media/ferramenta-reels-img3.jpeg';
import ferramenta_reels_img4 from '../Media/ferramenta-reels-img4.jpeg';
import ferramenta_reels_img5 from '../Media/ferramenta-reels-img5.jpeg';
import ferramenta_reels_img6 from '../Media/ferramenta-reels-img6.jpeg';
import ferramenta_reels_img7 from '../Media/ferramenta-reels-img7.jpeg';
import ferramenta_reels_img8 from '../Media/ferramenta-reels-img8.jpeg';
import ferramenta_reels_img9 from '../Media/ferramenta-reels-img9.jpeg';
import { api } from '../server/api';
import { HeaderMenu } from './HeaderMenu';
import LoadedPostDown from './LoadedResponses/LoadedPost';
import { Tools } from './Tools';
import { Faq } from './Tools/Faq';

const Reels = (props) => {
  const items = [
    {
      question: '  O que é preciso fazer para baixar Reels do Instagram?',
      answer:
        'Basicamente, o processo para baixar Reels funciona assim: você copia a URL do vídeo no Instagram e o cola em um campo específico daferramenta do ImpulsioneGram. Sendo necessário deixar o perfilaberto na rede social para que tudo saia como o esperado.',
    },
    {
      question:
        ' O proprietário do Reels vai saber que baixei o conteúdo dele?',
      answer:
        '   Não. O proprietário e nenhuma outra pessoa saberá que você fez o processo de baixar Reels. No ImpulsioneGram, você tem total segurança e privacidade para fazer o download de quantos vídeos quiser sem o menor problema.',
    },
    {
      question: 'Como repostar vídeos no Instagram?',
      answer:
        '  Se um dos seus objetivos em baixar Reels for repostar os vídeos no seu perfil do Instagram, saiba que temos uma ferramenta específica para fazer isso. Ela facilita o processo desse tipo de publicação e dá o crédito para o Instagrammer original da postagem.',
    },
  ];

  const [reelUrl, setReelUrl] = useState();
  const [reelId, setReelId] = useState();
  const [videoUrl, setVideoUrl] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [responseObj, setResponseObj] = useState();

  function getId(url) {
    if (url.includes('reel/')) {
      return url.split('reel/')[1].split(' ')[0].slice(0, 11);
    } else {
      return url.split('p/')[1].split(' ')[0].slice(0, 11);
    }
  }

  function onChangehandler(e) {
    setReelUrl(e.target.value);
  }

  function submitHandler(e) {
    e.preventDefault();
    if (reelUrl.length === 0) {
      alert('Link do Reels vazio!');
      return (
        <div className="error-page">
          <h2>Nenhum Reels encontrado!</h2>
          <p>Veja se você digitou o link corretamente.</p>
        </div>
      );
    }
    setIsLoading(true);
    fetchReel();
  }

  async function fetchReel() {
    const reelId = getId(reelUrl);
    setReelId(reelId);
    if (reelId.length !== 11) {
      alert('Invaid Reel URL');
      setIsLoading(false);

      return;
    }
    try {
      const { data } = await api.get(`reels/${reelId}`, {
        headers: {
          token:
            'dcbbf9d1dd87939fdcf446d5fef2f8ec0ea4382cd4f51bc462211bf7ba83fd47',
        },
      });

      setResponseObj(data);
      setIsLoading(false);
      setHasLoaded(true);
    } catch (error) {
      console.log('🚀 ~ file: Video.jsx:85 ~ fetchPost ~ error:', error);
    }
  }
  const responsive = {
    1200: {
      items: 3,
    },
    800: {
      items: 3,
    },
    500: {
      items: 2,
    },
    0: {
      items: 1,
    },
  };

  const itemsReels = [
    <div className=" carrossel-item p-4  item-tools" data-value="1">
      <h3 className="text-color-black">PREPARE O REELS COM ANTECEDÊNCIA</h3>
      <p>
        Não adianta esperar que uma ideia mirabolante vai surgir do nada e o
        resultado disso será um Reels viral. Cá entre nós, isso não funciona.
        <br />
        Nesse sentido, prepare os vídeos com antecedência, com 1, 2 ou até 3
        semanas antes do momento da publicação.
        <br />
        melhor, analisar o que pode ser melhorado no Reels e deixá-lo perfeito
        para receber diversos views, curtidas e comentários, por exemplo.
        <br />
        Para isso, uma dica é planejar um cronograma de postagens com todos os
        Reels que já estão prontos, constando dia e horário que serão postados,
        vídeo, legenda e tudo mais.
      </p>
    </div>,
    <div className=" p-4  item-tools" data-value="2">
      <h3>2. FIQUE DE OLHO NAS HASHTAGS TENDÊNCIAS</h3>
      <p>
        Para bombar seus Reels no Instagram, você precisa estar com um olho na
        produção de conteúdo e outro nas tendências da funcionalidade. Ou seja,
        nas músicas, ideias e brincadeiras que outros Instagrammers estão
        compartilhando.
      </p>
      <p>
        Essa simples análise da concorrência, já te coloca à frente para quem
        sabe ultrapassar 100 mil ou 1 milhão de visualizações em um Reels criado
        pela sua marca.
      </p>
    </div>,
    <div className=" p-4  item-tools" data-value="3">
      <h3>3. USE AS HASHTAGS CORRETAMENTE</h3>
      <p>
        Quando usadas corretamente, hashtags podem ampliar a capacidade de
        alcance dos seus Reels. É importante, por exemplo, que as hashtags
        escolhidas dialoguem de algum modo com o conteúdo a ser compartilhado,
        porque assim serão mais impactantes em seus números.
      </p>
      <p>
        Além disso, você precisa encontrar um equilíbrio na quantidade de
        hashtags que usa. Não podem ser poucas, mas também não podem ser muitas.
        Um bom parâmetro para você seguir é colocar entre 5 e 15 hashtags nas
        publicações.
      </p>
    </div>,
    <div className="item p-4  item-tools" data-value="4">
      <h3>1.Baixar perfil instagram</h3>
      <p>
        Baixar Reels Instagram é a ferramenta essencialmente criada para o
        download de vídeos no formato de Reels. Então, se você quer guardar
        aquele vídeo engraçado que viu para mostrar para seus amigos(a) mais
        tarde, por exemplo, essa solução é indispensável.
      </p>
    </div>,
  ];
  return (
    <>
      <Helmet>
        <title>Baixar Reels Instagram Grátis Online e Rápido [2023]</title>
        <meta
          content="Ainda não há uma forma nativa do Instagram para baixar Reels. Só que, com a nossa ferramenta, você pode salvar quantos vídeos quiser. Saiba mais!"
          name="description"
        />
      </Helmet>

      <Header />
      <div className="reel-response">
        {isLoading && <LoadingAnimation />}
        {hasLoaded && (
          <LoadedPostDown responseObj={responseObj} reelId={reelId} />
        )}
      </div>
      <section id="reel-section">
        <HeaderMenu
          submitHandler={submitHandler}
          onChangehandler={onChangehandler}
          description={
            'Insira o link do reels escolhido e faça o download de forma online e gratuita.'
          }
          text_description={'BAIXE REELS DO INSTAGRAM'}
          placeholder={'Digitar link do Reels'}
        />
      </section>
      <div className="background-white   py-5 color-grey-700">
        <div className="col-12 d-md-flex container">
          <div className="col-md-7 col-12">
            <div className="container text-left">
              <h1 className="text-center pb-5">
                Baixar Reels do Instagram Grátis Online e Rápido [2023]
              </h1>
              <p>
                Gosta de consumir aqueles vídeos curtos do Instagram? Então,
                <strong>baixar Reels</strong> é a ferramenta que você precisa
                para revê-los em um outro momento, compartilhá-lo por fora da
                <a
                  href="https://www.impulsionegram.com.br/blog/instagram-guia-completo/"
                  target="_blank"
                  rel="noreferrer"
                >
                  plataforma
                </a>
                . ou usar como referência para criar seus próprios conteúdos.
              </p>
              <p>
                Desde que foi criada, essa funcionalidade do Instagram virou uma
                verdadeira febre entre o público. De acordo com dados do Opinion
                Box, empresa de pesquisa do mercado online,{' '}
                <a
                  href="https://blog.opinionbox.com/pesquisa-instagram/#:~:text=Al%C3%A9m%20disso%2C%20a%20propor%C3%A7%C3%A3o%20de%20usu%C3%A1rios%20que%20assistem%20Reels%20pelo,de%2074%25%20para%2063%25."
                  target="_blank"
                  rel="noreferrer"
                >
                  67% dos usuários da plataforma vê pelo menos um vídeo de Reels
                  por dia
                </a>
                .
              </p>
              <p>
                Embora seja rival do TikTok e tenha características semelhantes
                à pioneira do mercado, o{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/como-fazer-reels-no-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Reels
                </a>{' '}
                possui vantagens únicas. Sobretudo, porque é um recurso
                integrado às demais funções da rede social.
              </p>
              <p>
                Em outras palavras, o Reels une o útil ao agradável, de modo que
                conquista milhares de pessoas, profissionais e empresas
                diariamente, já que consegue atender com eficiência diferentes
                necessidades.
              </p>
              <p>
                Contudo, há uma função que todos sentem falta na funcionalidade,
                isto é, baixar Reels. De fato, o Instagram ainda não tem uma
                opção assim. Sendo possível salvar seus vídeos favoritos apenas
                por{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/automacao-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  ferramentas de terceiros
                </a>
                .
              </p>
              <p>
                Portanto, vamos ensiná-lo justamente como baixar Reels, tanto
                pelo PC como pelo smartphone, através da ferramenta do
                ImpulsioneGram. Com isso, você pode fazer o download de quantos
                vídeos curtos quiser de forma online, grátis e rápida.
              </p>
              <p>Boa leitura!</p>
            </div>
          </div>
          <div className="col-md-5 col-12">
            <img
              className=" img-fluid img-responsive"
              src={retangle}
              alt="publicação instagram ícone três pontos topo lateral direita"
              width={'auto'}
            />
          </div>
        </div>

        <div className="  background-gray">
          <div className="container col-12 d-md-flex justify-content-center align-items-center py-5">
            <div className="col-md-5 col-12 pe-4">
              <Carousel
                emulateTouch={true}
                infiniteLoop={true}
                showStatus={false}
                showThumbs={false}
              >
                <div>
                  <img
                    src={ferramenta_reels_img1}
                    alt="reels instagram ícone três pontos topo lateral direita"
                    className="img-fluid img-responsive"
                  />
                </div>
                <div>
                  <img
                    src={ferramenta_reels_img2}
                    alt="seta indicando para copiar link reels Instagram"
                    className="img-fluid img-responsive"
                  />
                </div>
              </Carousel>
            </div>
            <div className="col-md-7 col-12">
              <h2 className="text-center py-4">
                Como baixar vídeo Reels pelo computador?
              </h2>
              <div className="text-left">
                <h4 className="pb-3">1. Copie a URL do Reels</h4>
                <p>
                  Para baixar Reels pelo{' '}
                  <a
                    href="https://www.impulsionegram.com.br/blog/postar-foto-instagram-pc/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    computador
                  </a>
                  , primeiramente copie o link da publicação, acessando a versão
                  desktop do Instagram. Há dois métodos para salvar o link na
                  área de transferência do PC: barra de endereço e ícone com
                  “três pontinhos”.
                </p>

                <p>
                  No primeiro, você deve clicar na barra com o endereço do site
                  que fica na parte superior da sua tela. Em seguida, precisa
                  usar os seguintes atalhos: Ctrl+A e Ctrl+C.
                </p>

                <p>
                  Enquanto no segundo, é necessário clicar sobre o ícone de três
                  pontinhos que fica no canto superior direito da publicação.
                  Logo após, selecione a opção “Copiar link”.
                </p>

                <p>
                  Enquanto no segundo, é necessário clicar sobre o ícone de três
                  pontinhos que fica no canto superior direito da publicação.
                  Logo após, selecione a opção “Copiar link”.
                </p>

                <h4 className="pb-3">
                  2. Vá no site das ferramentas do ImpulsioneGram
                </h4>

                <p>
                  Feito isso, acesse a página das ferramentas do ImpulsioneGram.
                  Você pode acessá-la subindo essa página até o topo.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container col-12 d-md-flex justify-content-center align-items-center py-5">
          <div className="col-md-7 col-12">
            <h4 className="pb-3">3. Selecione “Reels”</h4>

            <p>
              Chegando na página inicial do site das ferramentas do
              ImpulsioneGram, perceba que há diversas opções na tela para você
              escolher. Neste caso, selecione Reels para começar o processo de
              baixá-lo.
            </p>

            <h4 className="pb-3">4. Cole a URL copiada</h4>

            <p>
              Lembra do link copiado no primeiro passo de baixar Reels pelo PC?
              Então, é hora de colocá-lo no campo “Digitar link do Reels” que
              vai aparecer na tela do seu computador.
            </p>

            <h4 className="pb-3">5. Faça o download</h4>

            <p>
              Colocou a URL no campo solicitado? Ótimo, falta pouco para acabar.
              Agora você só precisa clicar em “Download”. Dessa forma, o vídeo
              de Reels será carregado e você poderá abri-lo para conferir se
              está tudo certo ou selecionar novamente a opção "Download" para
              baixá-lo.
            </p>

            <h4 className="pb-3">6. Pronto!</h4>

            <p>
              Pronto! O passo a passo para baixar Reels pelo PC está concluído.
              Após o término do processo, o arquivo de vídeo normalmente vai
              para pasta “Download” do seu PC para você vê-lo no dia e{' '}
              <a
                href="https://www.impulsionegram.com.br/blog/melhores-horarios-postar-instagram/"
                target="_blank"
                rel="noreferrer"
              >
                horário
              </a>{' '}
              que quiser.
            </p>
          </div>
          <div className="col-md-5 col-12 pe-4">
            <Carousel
              emulateTouch={true}
              infiniteLoop={true}
              showStatus={false}
              showThumbs={false}
            >
              <div>
                <img
                  src={ferramenta_reels_img3}
                  alt="seta indicando ícone reels ferramenta ImpulsioneGram"
                  className="img-fluid img-responsive"
                />
              </div>
              <div>
                <img
                  src={ferramenta_reels_img4}
                  alt="caixa de escrita para digitar link do reels"
                  className="img-fluid img-responsive"
                />
              </div>
              <div>
                <img
                  src={ferramenta_reels_img5}
                  alt="tela borrada com seta apontando botão de download"
                  className="img-fluid img-responsive"
                />
              </div>
            </Carousel>
          </div>
        </div>
        <div className="background-gray py-5">
          <div className="container col-12 d-md-flex justify-content-center align-items-center">
            <div className="col-md-5 col-12 pe-4">
              <Carousel
                emulateTouch={true}
                infiniteLoop={true}
                showStatus={false}
                showThumbs={false}
              >
                <div>
                  <img
                    src={ferramenta_reels_img6}
                    alt="seta indicando três pontos reels Instagram"
                    className="img-fluid img-responsive"
                  />
                </div>
                <div>
                  <img
                    src={ferramenta_reels_img7}
                    alt="seta apontando para copiar link"
                    className="img-fluid img-responsive"
                  />
                </div>
              </Carousel>
            </div>
            <div className="col-md-7 col-12">
              <h2 className="text-center py-4">
                Como baixar Reels pelo smartphone?
              </h2>

              <h4 className="pb-3">1. Copie a URL do Reels</h4>

              <p>
                Assim como baixar Reels pelo PC, o processo pelo smartphone
                começa em copiar a URL do vídeo, deixando-o na área de
                transferência do seu celular. Para isso, clique no ícone de três
                pontinhos no canto superior da postagem.
              </p>

              <h4 className="pb-3">
                2. Entre no site das ferramentas do ImpulsioneGram
              </h4>

              <p>
                Suba até o início da página para acessar o menu das ferramentas.
              </p>
            </div>
          </div>
        </div>
        <div className="container col-12 d-md-flex justify-content-center align-items-center py-5">
          <div className="col-md-7 col-12">
            <h4 className="pb-3">3. Clique em “Reels”</h4>

            <p>
              Feito isso, repare que na página inicial do site há diversas
              opções para você selecionar. Como o objetivo do passo a passo é
              baixar Reels, clique em “Reels” para continuar o processo.
            </p>

            <h4 className="pb-3">4. Cole a URL copiada</h4>

            <p>
              Agora, você deve{' '}
              <a
                href="https://www.impulsionegram.com.br/blog/colocar-link-stories/"
                target="_blank"
                rel="noreferrer"
              >
                inserir o link
              </a>{' '}
              que copiou anteriormente no campo “Digitar link do Reels”. Para
              isso, segure seu dedo por dois segundos no campo para que apareça
              a opção “Colar” na sua tela.
            </p>

            <h4 className="pb-3">5. Faça o download do Reels</h4>

            <p>
              Em seguida, clique na opção “Download”. Assim, o vídeo será
              carregado na página para que você possa visualizá-lo, verificando
              se está tudo nos conformes com o Reels, ou baixá-lo, selecionando
              novamente o botão de “Download”.
            </p>

            <h4 className="pb-3">6. Pronto!</h4>

            <p>
              Pronto! O processo para baixar Reels está finalizado. Normalmente,
              você pode encontrar o arquivo na pasta “Download” do seu
              dispositivo para vê-lo quantas vezes quiser.
            </p>
          </div>
          <div className="col-md-5 col-12 pe-4">
            <Carousel
              emulateTouch={true}
              infiniteLoop={true}
              showStatus={false}
              showThumbs={false}
            >
              <div>
                <img
                  src={ferramenta_reels_img8}
                  alt="print tela celular com seta indicando para ícone de reels"
                  className="img-fluid img-responsive"
                />
              </div>
              <div>
                <img
                  src={ferramenta_reels_img9}
                  alt="area para digitar link do reels em destaque"
                  className="img-fluid img-responsive"
                />
              </div>
              <div>
                <img
                  src={ferramenta_reels_img10}
                  alt="tela borrada com seta indicando para botão de download"
                  className="img-fluid img-responsive"
                />
              </div>
            </Carousel>
          </div>
        </div>
      </div>

      <div class="cta-section footer-cta py-24 bg-pattern pattern-3 ">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-9 col-lg-10 col-xl-10">
              <div class="text-center dark-mode-texts">
                <h2 class="gr-text-2 mb-12">COMO FAZER SEUS REELS BOMBAREM?</h2>{' '}
                <p class="text-white mb-0 mt-6">
                  Agora que você já sabe como baixar Reels tanto pelo PC quanto
                  pelo smartphone, destacamos abaixo algumas dicas para ajudá-lo
                  a conquistar mais visualizações na funcionalidade. Sabemos que
                  o Reels é extremamente importante para marcas que estão
                  fazendo marketing no Instagram. Sobretudo, por causa do grande
                  alcance que o recurso disponibiliza. Assim, queremos dar uma
                  mãozinha para fazer vídeos do Reels bombarem. Confira!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <AliceCarousel
          // disableButtonsControls={true}
          disableDotsControls={true}
          mouseTracking
          items={itemsReels}
          responsive={responsive}
          controlsStrategy="alternate"
        />
      </div>

      <Tools name_tool={'reels'} />
      <div className="background-white">
        <Faq
          title={'DÚVIDAS COMUNS RELACIONADAS A BAIXAR FOTOS DO INSTAGRAM'}
          questions={items}
        />
      </div>
      <div className="container my-5 simple-download">
        <h3 className="mb-4 text-center">
          BAIXAR REELS: FAÇA O DOWNLOAD DE QUANTOS VÍDEOS QUISER COM A
          FERRAMENTA DO IMPULSIONEGRAM!
        </h3>
        <div className="col-md-9 col-12 m-auto">
          <p>
            Nunca foi tão simples baixar Reels quanto com a ferramenta do
            ImpulsioneGram. O processo para fazer o download acontece de forma
            online, sem instalações ou cadastros. Assim, acompanha a rápida
            dinâmica do seu dia a dia.
          </p>
          <p>
            E o melhor: tudo isso é na faixa, 100% gratuito. Desse modo, você
            pode baixar quantos vídeos quiser, salvando os Reels mais engraçados
            em seu dispositivo para compartilhar com os amigos. Assim como,
            aqueles com milhares de views para usar como referência, por
            exemplo.
          </p>
          <p>
            Conte com a ferramenta do ImpulsioneGram, encontrada no topo dessa
            página, e não dê chance para qualquer dor de cabeça na hora de
            salvar seus Reels favoritos! É simples, rápido, online e 100% de
            graça.
          </p>
          <p>
            Comece a usar o quanto antes a nossa ferramenta de baixar reels
            Instagram, que pode ser acessada no topo da página, e nunca mais
            perca uma foto especial que encontrar na plataforma, salvando-a no
            seu computador ou smartphone.
          </p>
        </div>
      </div>
    </>
  );
};
export default Reels;
